import { ChecklistRecord } from '@/entities/checklist';
import { startInspection } from '@/ui/pages/checklist/StartInspection';
import { cloneChecklist } from '@/ui/pages/checklist/CloneChecklist';
import { openChecklistLogs } from '@/ui/pages/checklist/OpenChecklistLogs';

export const checklistIndexActions = (hasInspectionQuotaLeft: boolean, openActivityModal: Function) =>
  ({ row: checklist }: { row: ChecklistRecord }) => [
    checklist.authorizedTo.update && cloneChecklist(checklist),
    checklist.authorizedTo.conduct && startInspection(checklist, hasInspectionQuotaLeft),
    openChecklistLogs(checklist, openActivityModal),
  ];
